const Title = ({title}) => {
    return (
        <div className="title-container">
           <h1>{title}</h1> 
           <div></div>
        </div>
    )
}

export default Title
